import { EditAction } from '../shared/enum/EditAction';

export interface OrganogramModel {
    id: number,
    clientId: number,
    parentId: number | null,
    description: string,
    concurrent: boolean,
    active: boolean,
    endOfPeriod: Date | null,
    codeMetricDepartmentArea: number | null,
    codeMetricRelatedArea: number | null,
    codeMetricTheme: number | null,
    organograms: OrganogramModel[],
    editAction: EditAction,
}

export const organogramModelInitial: OrganogramModel = {
    id: 0,
    clientId: 0,
    parentId: null,
    description: '',
    concurrent: false,
    active: false,
    endOfPeriod: null,
    codeMetricDepartmentArea: null,
    codeMetricRelatedArea: null,
    codeMetricTheme: null,
    organograms: [],
    editAction: EditAction.NONE
};